import Link from "next/link";
import { linkStyle } from "@/styles/sharedStyle";
import { getUrlWithQuery } from "@/libs/url";
import { useRouter } from "next/router";

type Props = {};

export const ForgotPasswordLink = (props: Props) => {
  const router = useRouter();
  const { app } = router.query;

  return (
    <Link href={getUrlWithQuery("/forgot-password-send-mail", app)}>
      <a css={linkStyle}>パスワードを忘れた方</a>
    </Link>
  );
};
